export const VEHICLES_IMPORT_TEMPLATE_PATH =
  '/samples/vehicles-import-template.csv';
export const VEHICLES_IMPORT_TEMPLATE_FILENAME =
  'vehicles-import-template.csv';
